import { AboutContent } from '@backstage/plugin-catalog';
import { useEntity } from '@backstage/plugin-catalog-react';
import { Card, CardContent, CardHeader, createStyles, Divider, makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(createStyles({
    divider: { marginTop: '1em' }
}));


export const EntityInformationCard = () => {

    const { entity: entity } = useEntity();

    const { name, namespace } = entity.metadata;

    const description = `${name} ${namespace && (` in ${namespace}`)}`;

    const classes = useStyles();

    return (<Card>
        <CardHeader title="Information" subheader={description} />
        <Divider className={classes.divider} />
        <CardContent >
            <AboutContent entity={entity} />
        </CardContent>
    </Card>);
}
